exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[disabled=\"\"] {\n    background-color: #ddd;\n    border: 0;\n    transition: none;\n}\n\n.result {\n    padding: 10px;\n    margin: 10px 0;\n    border: #0d57a6 1px solid;\n    color: #0d57a6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/css/priip-style.css
// module id = 342
// module chunks = 0